import { useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import {
  OrderInvoiceInfoDTO,
  StripeOrderDTO,
} from "../../Stripe/StripeOrderDTO.ts";

type CustomerInfoUpdate = {
  firstName: string;
  lastName: string;
};

export function useUpdateInvoiceBillingInfo() {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updateInvoiceBillingInfo = async (
    orderId: string,
    invoiceInfo: OrderInvoiceInfoDTO,
    customerInformation: CustomerInfoUpdate,
  ): Promise<StripeOrderDTO> => {
    const axiosInstance = createAxiosInstance();
    try {
      setLoading(true);
      const { data } = await axiosInstance.put<StripeOrderDTO>(
        `/admin/orders/${orderId}/invoice-info`,
        { invoiceInfo, customerInformation },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { updateInvoiceBillingInfo, loading };
}
